import React, {Component,PropTypes} from 'react'



class Sliderhandles extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value.split(","),
      opciones:[],
      
    
    };
    this.handleChange=this.handleChange.bind(this);
   
  }


  handleChange(event) {

    
    if ( event.target.id == "esponsors"){

  // don't update it


    } else {

// modificar el valor 
     let array_update = [];

     
     for (var i=0 ; i < this.state.value.length; i++){

    
        if ( event.target.id == this.state.opciones[i].name){

           // El valor que hay que actualizar es el del event
           array_update[i] = event.target.value;

        } else {
        // El valor que hay que actualizar es el del valor
          array_update[i] =  this.state.opciones[i].value;

        }

       

     }

     this.setState({value: array_update});
     this.updateOptions();
     console.log(array_update.toString());
     this.props.updateAction(this.props.theKey,array_update.toString());

    }
  
 
  }





updateOptions(){

   
    let  optionsFromProps = [];
    let  opciones = [];
    let  porcentage = [];
    var _this=this;

    
    var arraystringfreq = this.state.value;


  let sumatotal = 0;
   
  // Calcular suma
    for (var i=0; i < arraystringfreq.length ; i++){
  
      sumatotal = sumatotal + parseInt(arraystringfreq[i],10);
  
    }


    for (var i=0; i < arraystringfreq.length ; i++){

        opciones[i] = parseInt(arraystringfreq[i],10);
        porcentage[i] = Math.round((opciones[i] / sumatotal) * 100);
       
         var newOption={

              value:opciones[i],
              name:this.props.options[i],
              porcentage:porcentage[i],
           }

     // console.log(newOption);
      optionsFromProps.push(newOption);
       

    }

    _this.setState({opciones:optionsFromProps})

 }

renderAnOption (value){


  return(
<div className="slidecontainer">
                      <label className="pull-left">Menor</label>
                      <label text-align="center"><b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {value.name} </b>{value.porcentage} % del tiempo total </label>
                      <label  className="pull-right">Mayor</label>
                      <input type="range" min="0" max="100" step="1" id={value.name} className="slidercode" value={value.value} onChange={this.handleChange}   />
             
            
              </div>  

  )
}


componentDidMount(){
 
    this.updateOptions();

}

  render() {

    
  
             
        return (

          <div className="form-group label-floating is-empty">                                    

                              {this.state.opciones.map((val)=>{
                               return this.renderAnOption(val);
                              })} 
     
         </div>

         
     
      )


  } 
}
export default Sliderhandles;

Sliderhandles.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/fields/Sliderhandles.js